import { render, staticRenderFns } from "./editPrize.vue?vue&type=template&id=6c60b768&scoped=true&"
import script from "./editPrize.vue?vue&type=script&lang=js&"
export * from "./editPrize.vue?vue&type=script&lang=js&"
import style0 from "./editPrize.vue?vue&type=style&index=0&id=6c60b768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60b768",
  null
  
)

export default component.exports